import axios, { AxiosResponse } from 'axios';

export const loginBankID = (jazyk: string) => {
    return axios({
        url: 'Portal/LoginBi',
        method: 'GET',
        params: {
            jazyk: jazyk
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const bankidStatus = (hash: string) => {
    return axios({
        method: 'GET',
        url: '/SUBodkaz/',
        params: {
            hash: hash
        }
    }).then(
        (resp: AxiosResponse<{ platnost: boolean; idosoby: number; stav: 'OK' | 'IDEN' | 'CHYBNY' | 'EXISTUJE' }>) =>
            resp.data
    );
};
export const bankidStatusOsoba = (token: string) => {
    return axios({
        method: 'GET',
        url: '/SUBodkaz/osoba',
        headers: {
            authorization: `Bearer ${token}` || ''
        }
    }).then(
        (
            resp: AxiosResponse<{
                jmeno: string;
                prijmeni: string;
            }>
        ) => resp.data
    );
};

export const biRedirectOvereni = (token: string) => {
    return axios({
        method: 'PUT',
        url: '/SUBodkaz/osoba/bankid',
        headers: {
            authorization: `Bearer ${token}` || ''
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const biLoginOvereni = (data: { hash: string; sms: string }) => {
    return axios({
        method: 'POST',
        url: '/SUBodkaz/prihlasit',
        data: data
    }).then(
        (
            resp: AxiosResponse<{
                prihlasen: boolean;
                token: string;
                idosoby: number;
            }>
        ) => resp.data
    );
};
export const biOvereniSms = (hash: string) => {
    return axios({
        method: 'POST',
        url: '/SUBodkaz/sms',
        data: {
            hash: hash
        }
    });
};
